import Contact1 from "../Assets/Images/Contact/Contact-1.png";
import Contact2 from "../Assets/Images/Contact/Contact-2.png";
import Contact3 from "../Assets/Images/Contact/Contact-3.png";
import Contact4 from "../Assets/Images/Contact/Contact-4.png";
import Contact5 from "../Assets/Images/Contact/Contact-5.png";
import Contact6 from "../Assets/Images/Contact/Contact-6.png";

export const contactData = [Contact1, Contact2, Contact3, Contact4, Contact5, Contact6];